// 错误信息配置

export default {
    '400': 'Error request',
    '401': 'Unauthorized, please log in again',
    '403': 'Deny access',
    '404': 'Request error, this resource was not found',
    '405': 'Request method is not allowed',
    '408': 'Request timeout',
    '500': 'Server side error',
    '501': 'Network not implemented',
    '502': 'Network Error',
    '503': 'Services are not available',
    '504': 'Network timeout',
    '505': 'http version does not support this request',
    'default': 'Connection error'
}
